var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "Anime" }, [
    _c(
      "div",
      { staticClass: "Anime-container" },
      [
        _vm.preload || _vm.animeObject
          ? _c(_vm.animeDetailComponent, {
              tag: "component",
              attrs: { anime: _vm.animeObject },
            })
          : _vm._e(),
        _vm._v(" "),
        !_vm.preload
          ? _c("div", { staticClass: "buttons-container" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  on: { click: _vm.findRandomAnime },
                },
                [_vm._v("Choose a random anime")]
              ),
              _vm._v(" "),
              _vm.animeObject
                ? _c(
                    "a",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: {
                        href: _vm.animeObject.url.value,
                        target: "_blank",
                      },
                    },
                    [_vm._v("View on MyAnimeList")]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.error
          ? _c("div", { staticClass: "buttons-container" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  on: { click: _vm.findRandomAnime },
                },
                [_vm._v("Try again")]
              ),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }